import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Main from './components/Main.vue'

// Definiere deine Routen
const routes : Array<RouteRecordRaw> = [
  
  {
    path: '/',
    name: 'main',
    component: Main,
  },

]

// Erstelle den Router
const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
